import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CardContainerStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerStyles: CardContainerStyles = {
    cardDivider: {
        css: css`
            width: calc(100% - 20px);
            margin: 0px 38px 16px 40px;
            border-bottom: 1px solid ${getColor("common.border")};
            div {
                padding-top: 0px;
                padding-bottom: 0px;
                padding-left: 0.4px;
                padding-right: 0px;
                margin-bottom: 8px;
            }
        `,
    },
    gridItem: {
        width: 12,
    },
};

interface MyListCardContainerProps {
    extendedStyles?: CardContainerStyles;
    children?: React.ReactNode;
}

const MyListCardContainer: FC<MyListCardContainerProps> = ({ extendedStyles, children }) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.cardDivider} className="card_container__wrapper">
            <GridItem {...styles.gridItem}>{children}</GridItem>
        </StyledWrapper>
    );
};

export default MyListCardContainer;
